module.exports = __webpack_public_path__ + "static/media/Devour-Home-Image.59d51584.jpg";